import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — resets scroll to top on every route change.
 * Skips when navigating to a hash-anchor (e.g. /#tools) so anchor scrolling still works.
 * Also disables browser's automatic scroll restoration so back/forward consistently start at top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Disable browser's built-in scroll restoration once
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // If user explicitly navigated to a hash anchor, let the browser handle it
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // Small timeout to let new page render before scrolling
        const id = setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
        return () => clearTimeout(id);
      }
    }
    // Default: reset to top on any route change
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
}
